export default __webpack_public_path__ + "static/media/modal-4.dda6e747.png";